import(/* webpackMode: "eager" */ "/vercel/path0/app/(wrapper)/layout.tsx");
